import { BranchConstantModel } from './branch-constant.model';
import {ApplicationConstantResponseModel} from "./application-constant-response.model";
import {Role} from "../../../auth_modules/models/role.model";

export class DefaultFilterConstant {
  roleType: Array<Role> = new Array<Role>();
  branches: Array<BranchConstantModel> = new Array<BranchConstantModel>();
  status: Array<string> = new Array<string>();
  applicationConstants: Array<ApplicationConstantResponseModel> = new Array<ApplicationConstantResponseModel>();
  applicationConstantEnum: Array<string> = new Array<string>();
}
